import Apis from '@/Apis/_'
import EventBus from '@/plugins/EventBus'
import Vue from 'vue'
import { RequestOptionsProps } from '../types'
import useLoading from '../useLoading'
import { ProducaoNaoCalculadaPorGeracao, UseProducaoNaoCalculadaState } from './types'

// FXSR-2984/2989 — badge de produção nova não calculada na listagem de gerações de repasse e
// quantitativo dentro da geração. Estado próprio (não entra no FinanceiroStore).
const useProducaoNaoCalculada = (() => {
  const state = Vue.observable<UseProducaoNaoCalculadaState>({
    itensPorGeracaoId: {},
    idsCarregados: [],
  })

  const { closeLoading, showLoading } = useLoading()

  function setItens(ids: string[], data: ProducaoNaoCalculadaPorGeracao[]) {
    data.forEach((item) => {
      Vue.set(state.itensPorGeracaoId, item.geracaoRepasseId, item)
    })
    state.idsCarregados = Array.from(new Set([...state.idsCarregados, ...ids]))
  }

  // FXSR-2984/2989 — falha silenciosa por padrão (showToastError: false): é informação auxiliar,
  // não pode poluir a tela mais usada do fluxo financeiro (RNF-02 da spec).
  async function loadByGeracaoIds(ids: string[], {
    showLoading: shouldShowLoading = false,
    forceRefresh = false,
    showToastError = false,
  }: RequestOptionsProps = {}) {
    const idsParaBuscar = forceRefresh
      ? ids
      : ids.filter(id => !state.idsCarregados.includes(id))

    if (!idsParaBuscar.length) {
      return { success: true, data: [] }
    }

    if (shouldShowLoading) showLoading()
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProducaoNaoCalculadaPorGeracao(idsParaBuscar)
    if (response.success) {
      setItens(idsParaBuscar, response.data || [])
    } else if (showToastError) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Ocorreu um erro na requisição.',
        icon: 'warning',
        color: '#C62828',
      })
    }
    closeLoading()
    return response
  }

  function getByGeracaoId(geracaoRepasseId: string): ProducaoNaoCalculadaPorGeracao | undefined {
    return state.itensPorGeracaoId[geracaoRepasseId]
  }

  return {
    get itensPorGeracaoId() {
      return state.itensPorGeracaoId
    },
    loadByGeracaoIds,
    getByGeracaoId,
  }
})()

export default useProducaoNaoCalculada
